import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { ValidationError } from '../../../../../domain/error.model';
import { Offer, PolicyholderRequest } from '../../../../../domain/offer.domain';
import { Party } from '../../../../../domain/party.domain';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { AsideAction } from '../../../store/aside.action';
import { ErrorsState } from '../../../store/errors.state';
import { OfferAction } from '../../../store/offer.action';
import { OfferState } from '../../../store/offer.state';

@Component({
    selector: 'app-party-edit-aside',
    templateUrl: './party-edit-aside.component.html',
    styleUrls: ['./party-edit-aside.component.scss']
})
export class PartyEditAsideComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    offer: Offer;
    isPolicyholder: boolean;
    insured: Party;
    policyholder: PolicyholderRequest;

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];

    matchers = {
        global: new LsnErrorStateMatcher(this, null),
        policyholderIsInsuredPerson: new LsnErrorStateMatcher(this, 'policyholderIsInsuredPerson'),
    };

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(OfferState.getOffer).subscribe(offer => this.offer = cloneDeep(offer)),
            this.store.select(OfferState.getInsured).subscribe(party => this.insured = cloneDeep(party)),
            this.store.select(OfferState.getPolicyholder).subscribe(policyholder => this.policyholder = cloneDeep(policyholder)),
            this.store.select(OfferState.getIsPolicyholder).subscribe(isPolicyholder => this.isPolicyholder = isPolicyholder),
            this.store.select(OfferState.getIsPolicyholder).subscribe(isPolicyholder => this.isPolicyholder = isPolicyholder),
            this.store.select(ErrorsState.getAsideErrors).subscribe(errors => this.errors = errors),
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    close() {
        this.store.dispatch(AsideAction.CloseRight());
    }

    save() {
        if (this.isPolicyholder) {
            this.store.dispatch(new OfferAction.SavePolicyholder(this.offer.id, this.policyholder));
        } else {
            this.store.dispatch(new OfferAction.SaveInsured(this.offer.id, this.insured));
        }
    }
}
